import type { IconProps } from '@magicschool/spellbook/components/Icon';
import { Icon } from '@magicschool/spellbook/components/Icon';
import { Slot } from '@magicschool/spellbook/components/Slot';
import type { SpinnerProps } from '@magicschool/spellbook/components/Spinner';
import { Spinner } from '@magicschool/spellbook/components/Spinner';
import { getControlIconSize } from '@magicschool/spellbook/lib/controls';
import { cn } from '@magicschool/spellbook/lib/utils';

export const ButtonLeadingIconSlot = Slot<IconProps>({
  displayName: 'Button.LeadingIcon',
  renderDefault: ({ name = 'square-dashed', size: providedSize, ...props }) => {
    const size = getControlIconSize(providedSize);
    return <Icon data-spellbook-name="button-leading-icon" name={name} size={size} {...props} />;
  },
});

export const ButtonTrailingIconSlot = Slot<IconProps>({
  displayName: 'Button.TrailingIcon',
  renderDefault: ({ name = 'square-dashed', size: providedSize, ...props }) => {
    const size = getControlIconSize(providedSize);
    return <Icon data-spellbook-name="button-trailing-icon" name={name} size={size} {...props} />;
  },
});

export const ButtonToggleIconSlot = Slot<IconProps>({
  displayName: 'Button.ToggleIcon',
  preventOverride: true,
  renderDefault: ({ name = 'chevron-down', className, size: providedSize, ...props }) => {
    const size = getControlIconSize(providedSize);
    return (
      <Icon
        data-spellbook-name="button-toggle-icon"
        name={name}
        size={size}
        aria-hidden="true"
        role="presentation"
        className={cn('transform', 'group-data-[state=open]/button:rotate-180', 'group-aria-expanded/button:rotate-180', className)}
        {...props}
      />
    );
  },
});

export const ButtonSpinnerSlot = Slot<SpinnerProps>({
  displayName: 'Button.Spinner',
  isRenderedByDefault: true,
  renderDefault: ({ size: providedSize, ...props }) => {
    const size = getControlIconSize(providedSize);
    return <Spinner data-spellbook-name="button-spinner" size={size} {...props} />;
  },
});
